var _path, _rect, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 86,
    viewBox: "0 0 68 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H7C3.68629 10 1 12.6863 1 16V79C1 82.3137 3.68629 85 7 85H61C64.3137 85 67 82.3137 67 79V16C67 12.6863 64.3137 10 61 10H52",
    stroke: "#1C1919",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 1,
    width: 34,
    height: 17,
    rx: 6,
    stroke: "#1C1919",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 48,
    r: 22,
    fill: "#6BE3A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49.2963L30.1861 52.3307C30.5776 52.7035 31.1945 52.6977 31.5789 52.3175L41 43",
    stroke: "#1C1919",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/ResetIcon.4a52b40b5ea8acf0dd4a4be9847873d3.svg";
export { ForwardRef as ReactComponent };